// Shared editor primitives used by tables and sub-section panels.
// Field.jsx is the labeled-input pattern; these are the unlabeled / inline
// variants and the toggle / sum-to-one-bar widgets.

export function NumInput({
  value,
  onChange,
  step = 1,
  decimals,
  pct = false,
  suffix,
  ariaLabel,
  className = '',
}) {
  const display = pct ? value * 100 : value;
  const dec = decimals != null ? decimals : pct ? 2 : step < 1 ? 2 : 0;
  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      <input
        type="number"
        aria-label={ariaLabel}
        value={Number(display.toFixed(dec))}
        step={pct ? step * 100 : step}
        onChange={(e) => {
          const raw = parseFloat(e.target.value);
          if (Number.isNaN(raw)) return;
          onChange(pct ? raw / 100 : raw);
        }}
        className="w-20 h-8 rounded-sw bg-carbon-50 border border-carbon-100 px-2 text-right label num-tabular text-carbon-800 outline-none focus:border-carbon-800"
      />
      {pct && <span className="label text-carbon-400">%</span>}
      {suffix && !pct && <span className="label text-carbon-400">{suffix}</span>}
    </div>
  );
}

export function Toggle({ checked, onChange, ariaLabel }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 rounded-full transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ice-400 ${
        checked ? 'bg-carbon-800' : 'bg-carbon-200'
      }`}
    >
      <span
        className={`block h-4 w-4 rounded-full bg-white shadow-sm transition-transform mt-0.5 ${
          checked ? 'translate-x-4' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}

export function SumToOneBar({ values, label = 'Sum' }) {
  const sum = Object.values(values).reduce((a, n) => a + (typeof n === 'number' ? n : 0), 0);
  const ok = Math.abs(sum - 1) < 1e-6;
  const tooHigh = sum > 1 + 1e-6;
  return (
    <div className="flex items-center gap-3">
      <div className="h-2 w-40 rounded-full bg-carbon-100 overflow-hidden">
        <div
          className={`h-full transition-all duration-200 ${
            ok ? 'bg-mint-500' : tooHigh ? 'bg-rose-500' : 'bg-ice-500'
          }`}
          style={{ width: `${Math.min(100, sum * 100)}%` }}
        />
      </div>
      <span
        className={`label num-tabular ${
          ok ? 'text-mint-800' : tooHigh ? 'text-rose-700' : 'text-carbon-700'
        }`}
      >
        {label ? `${label}: ` : ''}
        {(sum * 100).toFixed(1)}%
      </span>
    </div>
  );
}
